// src/pages/auth/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSwitcherAuth from '../../components/LanguageSwitcherAuth';
import '../../styles/auth.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();
  const { t } = useTranslation('auth');

  async function handleSubmit(e) {
    e.preventDefault();
    
    try {
      setMessage('');
      setError('');
      setLoading(true);
      await resetPassword(email);
      setMessage(t('messages.resetPasswordSuccess'));
    } catch (error) {
      console.error(error);
      setError(t('messages.resetPasswordError'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <LanguageSwitcherAuth />
      <div className="auth-form-container">
        <div className="auth-logo-container">
          <img 
            src="/48x48.png" 
            srcSet="/48x48.png 1x, /96x96.png 2x, /144x144.png 3x"
            alt={t('alt.klokifyLogo')} 
            className="auth-logo" 
          />
          <h1 className="auth-brand-name">Klokify</h1>
        </div>
        <h2>{t('titles.resetPassword')}</h2>
        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('labels.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? t('buttons.sending') : t('buttons.resetPassword')}
          </button>
        </form>
        
        <div className="auth-links">
          <Link to="/admin/login">{t('links.backToLogin')}</Link>
        </div>
      </div>
    </div>
  );
}